import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const UpdatePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [userId, setUserId] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [searchParams] = useSearchParams();
  const verifyToken = searchParams.get("token");

  useEffect(() => {
    const checkTokenVerify = async () => {
      if (!verifyToken) return;

      try {
        const response = await axios.post(`${API_BASE_URL}/verify-token`, {
          verify_token: verifyToken,
        });

        if (response.data.status === "success") {
          setUserId(response.data.id);
        } else {
          setError("Invalid or expired token.");
        }
      } catch (err) {
        setError("Invalid or expired token.");
        console.error("Verification Error:", err);
      }
    };

    checkTokenVerify();
  }, [verifyToken, API_BASE_URL]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    let validationErrors = {};

    if (!newPassword) {
      validationErrors.password = "Password is required";
    }
    if (!confirmPassword) {
      validationErrors.confirmPassword = "Confirm Password is required";
    }

    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}set-password/${userId}`, {
        password: newPassword,
        confirmPassword: confirmPassword,
      });

      if (response.status === 200) {
        setMessage("Password has been updated successfully!");
        navigate("/");
      } else {
        setError(
          response.data.message || "An error occurred while updating the password."
        );
      }
    } catch (err) {
      if (err.response && err.response.data) {
        const data = err.response.data;

        if (data.args && Array.isArray(data.args)) {
          const firstError = data.args[0];

          if (firstError._schema && Array.isArray(firstError._schema)) {
            setError({ confirmPassword: firstError._schema[0] });
          } else {
            setError(firstError);
          }
        } else if (data.invalid) {
          setError({ invalid: data.invalid });
        } else {
          setError({ general: "An error occurred. Please try again later." });
        }
      } else {
        setError({ general: "An error occurred. Please try again later." });
      }
    }
  };

  if (error === "Invalid or expired token.") {
    return (
      <div className="container">
        <div className="reset-password-page text-center">
          <h2>Email Link has Expired</h2>
          <p>Please request a new password reset link.</p>
          <button className="btn ls-btn main-btn" onClick={() => window.open("https://localshouts.com/vcards", "_blank")}>
            Resend Link
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="reset-password-page">
        <h2 className="text-center">Set your Password</h2>
        {message && <p style={{ color: "green" }}>{message}</p>}

        <div className="form rounded-2 white-box-shadow">
          <form className="reset-password-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Password:</label>
              <div className="form-field position-relative">
                <i className="fa-solid fa-lock"></i>
                <input
                  className="form-control"
                  placeholder="New Password"
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setError((prev) => ({ ...prev, password: "" }));
                  }}
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "15px",
                    cursor: "pointer",
                    color: "gray",
                  }}
                >
                  {showPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                </span>
                {error.password && (
                  <small className="text-danger">{error.password}</small>
                )}
              </div>
            </div>

            <div className="form-group mt-3">
              <label>Confirm Password:</label>
              <div className="form-field position-relative">
                <i className="fa-solid fa-lock"></i>
                <input
                  className="form-control"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setError((prev) => ({ ...prev, confirmPassword: "" }));
                  }}
                />
                <span
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "15px",
                    cursor: "pointer",
                    color: "gray",
                  }}
                >
                  {showConfirmPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                </span>
                {error.confirmPassword && (
                  <small className="text-danger">{error.confirmPassword}</small>
                )}
              </div>
            </div>

            <div className="form-group form-btns mt-3">
              <div className="form-field">
                <button type="submit" className="ls-btn">
                  Update Password
                </button>
              </div>
            </div>

            {error.general && (
              <p className="text-danger text-center mt-2">{error.general}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
